class CartReservation {
  constructor() {
    this.reservationTime = null; // Will be set from data attribute
    this.timerElement = null;
    this.countdownInterval = null;
    this.expirationTime = null;
    this.previousCartState = {};
    this.init();
  }

  init() {
    // Listen for section rendering
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('cart-drawer')) {
        this.setupTimer();
      }
    });

    // Listen for cart drawer open
    document.addEventListener('cart-drawer:open', () => {
      this.setupTimer();
    });

    // Listen for cart drawer close
    document.addEventListener('cart-drawer:close', () => {
      this.stopCountdown();
    });

    // Initialize cart monitoring
    this.initCartMonitoring();
  }

  initCartMonitoring() {
    // Save the original fetch method
    const originalFetch = window.fetch;

    // Override fetch to monitor cart-related requests
    window.fetch = async function(...args) {
      const url = args[0];
      if (typeof url === 'string' && (
        url.includes('/cart/add.js') || 
        url.includes('/cart/update.js') || 
        url.includes('/cart/change.js') ||
        url.includes('/cart/clear.js')
      )) {
        // Wait for the original fetch to complete
        const response = await originalFetch.apply(window, args);
        
        // Clone the response so we can read it multiple times
        const clone = response.clone();
        
        // Check if the request was successful
        if (response.ok) {
          try {
            const data = await clone.json();
            if (data) {
              window.cartReservation.handleCartUpdate();
            }
          } catch (e) {
            console.error('Error parsing cart response:', e);
          }
        }
        
        return response;
      }
      
      // For non-cart requests, proceed normally
      return originalFetch.apply(window, args);
    };

    // Start polling for cart changes
    this.startCartPolling();
  }

  startCartPolling() {
    // Initial cart state
    this.checkCartUpdates();

    // Poll every 2 seconds
    setInterval(() => this.checkCartUpdates(), 2000);
  }

  async checkCartUpdates() {
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();
      
      // Compare with previous state
      if (JSON.stringify(cart) !== JSON.stringify(this.previousCartState)) {
        this.handleCartUpdate();
        this.previousCartState = cart;
      }
    } catch (error) {
      console.error('Error checking cart updates:', error);
    }
  }

  handleCartUpdate() {
    this.setupTimer();
  }

  setupTimer() {
    // Clear any existing interval
    this.stopCountdown();

    // Get stored expiration time
    const storedExpiration = localStorage.getItem('cartExpirationTime');
    const hasItems = document.querySelector('cart-drawer-items:not(.is-empty)');

    if (hasItems) {
      // Wait for the cart-reservation element to be available
      this.waitForElement('#cart-reservation', () => {
        this.timerElement = document.getElementById('cart-reservation');
        
        // Get reservation time from data attribute
        const reservationTimeAttr = this.timerElement.getAttribute('data-cart-reservation-time');
        this.reservationTime = reservationTimeAttr ? parseInt(reservationTimeAttr) : 5; // Default to 10 if not set
        
        if (storedExpiration) {
          this.expirationTime = new Date(parseInt(storedExpiration));
          // If expiration time is in the past, clear it
          if (this.expirationTime <= new Date()) {
            this.clearCart();
            return;
          }
        } else {
          // Set new expiration time
          this.expirationTime = new Date(Date.now() + this.reservationTime * 60 * 1000);
          localStorage.setItem('cartExpirationTime', this.expirationTime.getTime().toString());
        }
        this.startCountdown();
      });
    } else {
      localStorage.removeItem('cartExpirationTime');
    }
  }

  waitForElement(selector, callback, maxTries = 10) {
    let tries = 0;
    const checkElement = () => {
      const element = document.querySelector(selector);
      if (element) {
        callback();
      } else if (tries < maxTries) {
        tries++;
        setTimeout(checkElement, 100);
      }
    };
    checkElement();
  }

  startCountdown() {
    if (!this.timerElement) return;

    // Update timer immediately
    this.updateTimer();

    // Start countdown interval
    this.countdownInterval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.expirationTime = null;
  }

  updateTimer() {
    if (!this.timerElement || !this.expirationTime) return;

    const now = new Date();
    const timeLeft = this.expirationTime - now;

    if (timeLeft <= 0) {
      this.clearCart();
      return;
    }

    const minutes = Math.floor(timeLeft / (60 * 1000));
    const seconds = Math.floor((timeLeft % (60 * 1000)) / 1000);

    this.timerElement.innerHTML = `Your cart will expire in <strong>${minutes}:${seconds.toString().padStart(2, '0')}</strong> minutes`;
  }

  async clearCart() {
    this.stopCountdown();
    localStorage.removeItem('cartExpirationTime');
    
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        // Refresh the cart drawer
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }
}

// Initialize cart reservation when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.cartReservation = new CartReservation();
});


// document.addEventListener('DOMContentLoaded', function () {
//   document.addEventListener('click', async function (e) {
//     const btn = e.target.closest('.upsell-cta');
//     if (!btn) return;

//     const variantId = btn.getAttribute('data-id');
//     const sellingPlan = btn.getAttribute('data-selling-plan');
//     const packSize = parseInt(btn.getAttribute('data-pack-size'), 10);

//     // Helper: add to cart
//     const addToCart = async () => {
//       const body = {
//         items: [{
//           id: variantId,
//           quantity: 1,
//           ...(sellingPlan ? { selling_plan: sellingPlan } : {})
//         }]
//       };

//       const res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(body)
//       });

//       if (!res.ok) {
//         console.error('Failed to add item to cart');
//         return;
//       }

//       refreshCartDrawer();
//     };

//     // If pack size is 1 → just add, no need to clear cart
//     if (packSize === 1) {
//       await addToCart();
//       return;
//     }

//     // For packSize 2 or 3 → clear cart first
//     const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
//     if (!clearRes.ok) {
//       console.error('Failed to clear cart');
//       return;
//     }

//     // Now add the upsell product
//     await addToCart();
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-cta');
    if (!btn) return;

    const variantId = btn.getAttribute('data-id');
    const sellingPlan = btn.getAttribute('data-selling-plan');
    const packSize = parseInt(btn.getAttribute('data-pack-size'), 10);

    // Helper: add to cart
    const addToCart = async () => {
      const item = {
        id: variantId,
        quantity: 1,
      };

      // Add selling plan and Firstorderdate if applicable
      if (sellingPlan) {
        item.selling_plan = sellingPlan;
        item.properties = {
          Firstorderdate: "2025-12-15"
        };
      }

      const body = { items: [item] };

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(body)
      });

      if (!res.ok) {
        console.error('Failed to add item to cart');
        return;
      }

      refreshCartDrawer();
    };

    // If pack size is 1 → just add, no need to clear cart
    if (packSize === 1) {
      await addToCart();
      return;
    }

    // For packSize 2 or 3 → clear cart first
    const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
    if (!clearRes.ok) {
      console.error('Failed to clear cart');
      return;
    }

    // Now add the upsell product
    await addToCart();
  });
});

